export default "__VITE_ASSET__Ba_dV1Qj__"